import { WithClassnames, joinClassNames } from '@vertex-protocol/web-common';
import { DropdownUi, UpDownChevronIcon } from '@vertex-protocol/web-ui';
import { useEVMContext } from '@vertex-protocol/react-client';
import { MarketSwitcherItem } from 'client/modules/trading/hooks/useMarketSwitcher/types';
import { getArcaInstitutionalMarketDisplayName } from 'client/utils/markets/arcaInstitutionalMarkets';
import Image from 'next/image';

interface Props {
  selectedMarket: MarketSwitcherItem | undefined;
  disabled: boolean;
  open: boolean;
  onClick?: () => void;
}

export function TradingMarketSwitcherPopoverTrigger({
  className,
  selectedMarket,
  disabled,
  open,
  onClick,
}: WithClassnames<Props>) {
  const { primaryChainEnv } = useEVMContext();
  const leftSide = (() => {
    const content = (() => {
      if (open || !selectedMarket) {
        return 'Choose Market';
      }

      const displayName = getArcaInstitutionalMarketDisplayName({
        chainEnv: primaryChainEnv,
        productId: selectedMarket.productId,
        metadata: {
          symbol: selectedMarket.market.symbol,
          marketName: selectedMarket.market.marketName,
          marketCategories: selectedMarket.market.categories,
        },
      });

      return (
        <>
          {selectedMarket && (
            <Image
              src={selectedMarket.market.icon.asset}
              alt={selectedMarket.market.symbol}
              className="h-6 w-auto"
            />
          )}
          {displayName}
        </>
      );
    })();

    return (
      <div className="text-text-primary flex flex-1 items-center gap-x-2 text-base">
        {content}
      </div>
    );
  })();

  const rightSide = (() => {
    const content = open ? 'Close' : 'All Markets';
    return (
      <div className="text-text-tertiary flex items-center gap-x-2 text-xs">
        {content}
        <UpDownChevronIcon size={20} open={open} />
      </div>
    );
  })();

  return (
    <DropdownUi.Trigger
      className={joinClassNames(
        'p-3',
        'overflow-hidden',
        className,
      )}
      disabled={disabled}
      onClick={onClick}
    >
      {leftSide}
      {rightSide}
    </DropdownUi.Trigger>
  );
}
